module.exports = __webpack_public_path__ + "img/thumbnail_CommonWarthog_j_albino.57212504.png";